module.exports = __webpack_public_path__ + "img/thumb_05.8a9fde37.jpg";